import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationModule } from '@psu/components/notification-ngrx';
import { FilterModule, OkayDialogModule } from '@starfish-access/core';
import { WorkflowDetailsModule, WorkflowHistoryModule } from '@starfish-access/shared';
import { DetailsComponent } from './details.component';
import { DetailsEffects } from './details.effects';
import { detailsListReducer } from './details.reducer';
import { routes } from './details.routing';
import { DetailsService } from './details.service';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NotificationModule,
    MatTableModule,
    FlexLayoutModule,
    FilterModule,
    WorkflowDetailsModule,
    WorkflowHistoryModule,
    OkayDialogModule,
    StoreModule.forFeature('detailsList', detailsListReducer),
    EffectsModule.forFeature([DetailsEffects]),
  ],
  declarations: [DetailsComponent],
  exports: [RouterModule],
  providers: [DetailsService],
})
export class DetailsModule {}
